import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Row,
  Col,
  InputGroup,
  FormText,
  Table,
  DropdownButton,
  Dropdown,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { toast } from "react-toastify";
import {
  IconUser,
  IconFileDescription,
  IconCalendarWeek,
  IconTrash,
  IconEdit,
} from "@tabler/icons-react";
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import usePostRequest from "../../hooks/usePostRequest";
import { API_ENDPOINTS, handleKeyDown } from "../../constant/_constant";
import DatePicker from "react-datepicker";
import { setContractName } from "../../redux/contrcatReducer";
import { useDispatch, useSelector } from "react-redux";
import { TreeSelect } from "primereact/treeselect";
import { useParams } from "react-router-dom";
import RfqIdEditPopup from "../lifecycle/RfqIdEditPopup";
function GeneralInformationForm({ isEditing, orderMade }) {
  const {
    control,
    watch,
    setValue,
    register,
    formState: { errors },
  } = useFormContext();
  const user = useSelector((state) => state.auth.user);

  const {
    data: fetchdata,
    isLoading,
    postData: fetchContract,
  } = usePostRequest(API_ENDPOINTS.GET_CONTRACT);

  const { rfq_id } = useParams();

  const {
    data: fetchdatas,
    isLoadings,
    postData: fetchRfq,
  } = usePostRequest(API_ENDPOINTS.GET_CUSTOMER_AUTOFILL);

  const { data: fetchProject, postData: fetchProjectData } = usePostRequest(
    API_ENDPOINTS.GET_SINGLE_VEHICLE,
  );

  const allowedRoles = ["super-admin"];
  const isSuperAdmin = user?.roles?.some((role) => allowedRoles.includes(role));
  const isDeptHead = user?.is_department_head;
  const dispatch = useDispatch();

  useEffect(() => {
    if (user) {
      setValue("sales_lead_name", `${user.first_name} ${user.last_name}`);
      setValue("sales_lead_email", user.email);
      setValue("sales_lead_phone", user.phone);
      setValue("sales_lead_username", user.username);
    }
  }, [user]);

  console.log("orderMadeorderMadeorderMade", orderMade);

  useEffect(() => {
    fetchContract();
  }, []);
  const [suggestionData, setSuggestionData] = useState([]);
  const [showCreateRfq, setShowCreateRfq] = useState(false);

  const opportunityTypeSelected = watch("opportunityType");

  const contractVehicleSelected = watch("contractVehicle");

  const dueDate = watch("dueDate");

  const [searchDebounces, setSearchDebounces] = useState({
    searchName: "",
  });

  const suggestionBoxRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionBoxRef.current &&
        !suggestionBoxRef.current.contains(event.target)
      ) {
        setSuggestionData(null);
        setSearchDebounces({ searchName: "" });
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const {
    fields: customFields,
    append: appendField,
    remove: removeField,
  } = useFieldArray({
    control,
    name: "custom_fields",
  });

  const [fieldType, setFieldType] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [customFieldError, setCustomFieldError] = useState("");

  // const handleAddCustomField = () => {
  //   if (!fieldType || !fieldName.trim()) {
  //     setCustomFieldError("Both field type and name are required.");
  //     return;
  //   }

  //   appendField({
  //     type: fieldType,
  //     field_name: fieldName.trim(),
  //     value: "",
  //   });

  //   // Clear state
  //   setFieldName("");
  //   setFieldType("");
  //   setCustomFieldError("");
  // };

  // const handleAddCustomField = () => {
  //   if (!fieldType || !fieldName.trim()) {
  //     setCustomFieldError("Both field type and name are required.");
  //     return;
  //   }

  //   if (fieldType === "dropdown") {
  //     const { title, options } = parseDropdownField(fieldName);
  //     if (!title) {
  //       setCustomFieldError("Please enter a valid dropdown title.");
  //       return;
  //     }
  //     if (options.length === 0) {
  //       setCustomFieldError(
  //         'Please provide options after a semicolon, e.g. "Label; Option1, Option2"'
  //       );
  //       return;
  //     }
  //     appendField({
  //       type: "dropdown",
  //       field_name: title,
  //       options: options,
  //       value: "",
  //     });
  //   } else {
  //     appendField({
  //       type: fieldType,
  //       field_name: fieldName.trim(),
  //       value: "",
  //     });
  //   }

  //   setFieldName("");
  //   setFieldType("");
  //   setCustomFieldError("");
  // };

  const handleAddCustomField = () => {
    if (fieldType === "dhs") {
      const alreadyExists = customFields.some(
        (f) => f.field_name === "DHS Order Type",
      );

      if (alreadyExists) {
        setCustomFieldError("DHS Order Type already added.");
        return;
      }

      appendField({
        type: "dropdown",
        field_name: "DHS Order Type",
        options: ["Field", "Academy", "N/A"],
        value: "",
      });

      setFieldType("");
      setCustomFieldError("");
      return;
    }

    if (!fieldType || !fieldName.trim()) {
      setCustomFieldError("Both field type and name are required.");
      return;
    }

    if (fieldType === "dropdown") {
      const { title, options } = parseDropdownField(fieldName);

      if (!title) {
        setCustomFieldError("Please enter a valid dropdown title.");
        return;
      }

      if (options.length === 0) {
        setCustomFieldError(
          'Please provide options after a semicolon, e.g. "Label; Option1, Option2"',
        );
        return;
      }

      appendField({
        type: "dropdown",
        field_name: title,
        options: options,
        value: "",
      });
    } else {
      appendField({
        type: fieldType,
        field_name: fieldName.trim(),
        value: "",
      });
    }

    setFieldName("");
    setFieldType("");
    setCustomFieldError("");
  };

  const handleRemoveCustomField = (index) => {
    removeField(index);
  };

  const handleCancelCustomField = () => {
    setFieldType("");
    setFieldName("");
  };

  useEffect(() => {
    if (!opportunityTypeSelected) {
      setValue("opportunityType", "RFQ");
    }
  }, [setValue, opportunityTypeSelected]);

  useEffect(() => {
    if (contractVehicleSelected === "3" && !rfq_id) {
      const alreadyExists = customFields.some(
        (f) => f.field_name === "DHS Order Type",
      );

      if (!alreadyExists) {
        appendField({
          type: "dropdown",
          field_name: "DHS Order Type",
          options: ["Field", "Academy", "N/A"],
          value: "",
        });
      }
    }
  }, [contractVehicleSelected, rfq_id, customFields]);

  // useEffect(() => {
  //   if (fetchdata?.data && !contractVehicleSelected && !isEditing) {
  //     // Set default contract vehicle only if none is selected
  //     const selectedVehicle = fetchdata.data[0]?.id; // You can change this logic based on default selection
  //     setValue("contractVehicle", selectedVehicle);
  //   }

  //   if (fetchdata?.data) {
  //     const contractName = fetchdata.data.find(
  //       (vehicle) => vehicle.id == contractVehicleSelected,
  //     )?.name;
  //     if (contractName) {
  //       dispatch(setContractName(contractName));
  //     }
  //   }
  // }, [fetchdata, contractVehicleSelected, isEditing, setValue]);

  const handleDropdownValue = (vehicleId) => {
    return vehicleId || "";
  };

  const CustomInput = ({ value, onClick }) => (
    <input
      className="form-control"
      type="text"
      value={value}
      placeholderText="Select a date"
      onClick={onClick}
      readOnly // Ensures text cannot be typed
      style={{ cursor: "pointer" }}
    />
  );

  const handleSearchByName = (e) => {
    setSearchDebounces({ searchName: e.target.value });
  };

  useEffect(() => {
    if (searchDebounces?.searchName?.length > 0) {
      fetchRfq(
        {
          first_name:
            searchDebounces?.searchName?.length > 0
              ? searchDebounces?.searchName
              : undefined,
          module_type: "ORDER",
        },
        onSuggestionSuccessData,
      );
    }
  }, [searchDebounces]);

  const onProjectDataSuccess = (data) => {
    const previousOrderType = watch("ordertype");
    const newOrderType = data?.data?.project?.order_type || "";

    setValue("organization_name", data?.data?.project?.organization_name || "");
    setValue("Opportunity_Description", data?.data?.project?.brief || "");
    // setValue("ordertype", data?.data?.project?.order_type || "DS");
    setValue("ordertype", newOrderType);

    if (
      newOrderType &&
      previousOrderType &&
      newOrderType !== previousOrderType
    ) {
      const orderTypeLabels = {
        DS: "Dropship",
        CRK: "Consolidate / Repack",
        M: "Manufacturing",
        KIT: "Kit",
        S: "Stock",
      };
      toast.success(
        `Selected Contract Vehicle updated your Order Type to the most common one – ${orderTypeLabels[newOrderType] || newOrderType}. If you did not intend changing that, please update the Order Type.`,
        { autoClose: 4000 },
      );
    }

    setValue(
      "order_Payment_Type",
      data?.data?.project?.order_payment_type || "",
    );
    setValue("custom_fields", data?.data?.project?.custom_fields || []);

    setValue(
      "notifyEmails",
      data?.data?.project?.notify_emails === 1 ? "1" : "0",
    );
    setValue(
      "notifyEmailsVendor",
      data?.data?.project?.notify_emails_vendor === 1 ? "1" : "0",
    );

    setValue(
      "estimateddelivery",
      data?.data?.project?.estimated_delivery || "",
    );
    setValue("payment_terms", data?.data?.project?.payment_term || "1");
    setValue("shipping_terms", data?.data?.project?.shipping_term || "");
    setValue(
      "payment_term_detail",
      data?.data?.project?.payment_term_detail || "",
    );
    setValue(
      "shipping_method_detail",
      data?.data?.project?.shipping_method_detail || "",
    );
    setValue("shipping_method", data?.data?.project?.shipping_method || "");
    setValue(
      "initial_consolidation",
      data?.data?.project?.initial_consolidation || "",
    );
    const emailsString = data?.data?.project?.team_emails;
    const emailsArray = emailsString ? emailsString.split(",") : [];
    setValue("notification_emails", emailsArray);
    const emailsStringOrderPending =
      data?.data?.project?.order_pending_notification_emails;
    const emailsArrayOrderPending = emailsStringOrderPending
      ? emailsStringOrderPending.split(",")
      : [];
    setValue("orderpending_notification_emails", emailsArrayOrderPending);
    const emailsStringOrderProgress =
      data?.data?.project?.order_progress_notification_emails;
    const emailsArrayOrderProgress = emailsStringOrderProgress
      ? emailsStringOrderProgress.split(",")
      : [];
    setValue("orderprogress_notification_emails", emailsArrayOrderProgress);

    setValue("contractOfficerName", data?.data?.project?.rfqKo?.name || "");
    setValue("contractOfficerEmail", data?.data?.project?.rfqKo?.email || "");
    setValue("contractOfficerPhone", data?.data?.project?.rfqKo?.phone || "");
    setValue(
      "contractOfficerAddress",
      data?.data?.project?.rfqKo?.address || "",
    );
    setValue(
      "shippingCustomerName",
      data?.data?.project?.rfqShipping?.name || "",
    );
    setValue(
      "shippingCustomerEmail",
      data?.data?.project?.rfqShipping?.email || "",
    );
    setValue(
      "shippingCustomerPhone",
      data?.data?.project?.rfqShipping?.phone || "",
    );
    setValue(
      "shippingCustomerAddress",
      data?.data?.project?.rfqShipping?.address || "",
    );
    setValue(
      "BillingCustomerName",
      data?.data?.project?.rfqBilling?.name || "",
    );
    setValue(
      "BillingCustomerEmail",
      data?.data?.project?.rfqBilling?.email || "",
    );
    setValue(
      "BillingCustomerPhone",
      data?.data?.project?.rfqBilling?.phone || "",
    );
    setValue(
      "BillingCustomerAddress",
      data?.data?.project?.rfqBilling?.address || "",
    );
    setValue("contractVehicletype", data?.data?.contract_vehicle_type || "");
  };

  const onSuggestionSuccessData = (data) => {
    setSuggestionData(data);
  };

  const handleSelectOrganization = (item) => {
    setValue("organization_name", item.display_name);

    setValue(
      "contractOfficerName",
      `${item?.first_name || ""} ${item?.last_name || ""}`,
    );
    setValue(
      "contractOfficerEmail",
      item?.primary_email ? item.primary_email.Address : "",
    );
    setValue(
      "contractOfficerPhone",
      item?.primary_phone ? item.primary_phone.FreeFormNumber : "",
    );
    setValue("contractOfficerAddress", item.address);

    setValue("shippingCustomerName", item?.shipping_name);
    setValue("shippingCustomerEmail", item?.shipping_email);
    setValue("shippingCustomerPhone", item?.shipping_phone);

    if (item?.shipping_address) {
      const address = item.shipping_address;
      const formattedAddress = [
        address.Line1,
        address.Line2,
        `${address.City || ""}${address.City ? "," : ""} ${
          address.CountrySubDivisionCode || ""
        } ${address.PostalCode || ""}`.trim(),
        address.Country,
      ]
        .filter((line) => line && line.trim() !== "") // Remove blank lines
        .join("\n");

      setValue("shippingCustomerAddress", formattedAddress);
    }

    setValue("BillingCustomerName", item?.billing_name);
    setValue("BillingCustomerEmail", item?.billing_email);
    setValue("BillingCustomerPhone", item?.billing_phone);

    if (item?.billing_address) {
      const address = item.billing_address;
      const formattedAddress = [
        address.Line1,
        address.Line2,
        `${address.City || ""}${address.City ? "," : ""} ${
          address.CountrySubDivisionCode || ""
        } ${address.PostalCode || ""}`.trim(),
        address.Country,
      ]
        .filter((line) => line && line.trim() !== "")
        .join("\n");
      setValue("BillingCustomerAddress", formattedAddress);
    }
    setSuggestionData(null);
  };

  const selectContractVehicle = (vehicleId) => {
    setValue("vehicleId", vehicleId);
    if (vehicleId) {
      fetchProjectData(
        {
          contract_type_id: vehicleId,
        },
        onProjectDataSuccess,
      );
    }
  };

  const contractVehicleNodes = (fetchdata?.data || []).map((vehicle) => ({
    key: String(vehicle.id),
    label: vehicle.name,
    selectable: true,
    children:
      vehicle.children?.map((child) => ({
        key: String(child.id),
        label: child.name,
        selectable: true,
        children: [], // extend to another level here if needed
      })) || [],
  }));

  const parseDropdownField = (input) => {
    const [titlePart, optionsPart] = input.split(";");
    const title = titlePart?.trim() || "";
    const options = optionsPart
      ? optionsPart
          .split(",")
          .map((o) => o.trim())
          .filter(Boolean)
      : [];
    return { title, options };
  };

  const openRfqPopup = () => {
    setShowCreateRfq(true);
  };

  return (
    <>
      <RfqIdEditPopup
        show={showCreateRfq}
        onClose={() => setShowCreateRfq(false)}
        rfqId={rfq_id}
      />
      <Row className="mb-3 mt-3">
        <Form.Group as={Col}>
          <div style={{ display: "flex", gap: "2px 18px", flexWrap: "wrap" }}>
            <Form.Label
              className="d-inline-block d-sm-inline w-100 w-sm-auto"
              style={{ fontWeight: "bold" }}
            >
              Opportunity Type:
            </Form.Label>

            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="RFQId"
                value="RFQ"
                {...register("opportunityType")}
              />
              <Form.Check.Label htmlFor="RFQId">RFQ</Form.Check.Label>
            </Form.Check>

            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="RFIId"
                value="RFI"
                {...register("opportunityType")}
              />

              <Form.Check.Label htmlFor="RFIId">RFI</Form.Check.Label>
            </Form.Check>

            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="RFPId"
                value="RFP"
                {...register("opportunityType")}
              />

              <Form.Check.Label htmlFor="RFPId">RFP</Form.Check.Label>
            </Form.Check>

            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="directSalesId"
                value="DIRECT_SALES"
                {...register("opportunityType")}
              />

              <Form.Check.Label htmlFor="directSalesId">
                Direct Sales
              </Form.Check.Label>
            </Form.Check>

            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="otherId"
                value="OTHER"
                {...register("opportunityType")}
              />
              <Form.Check.Label htmlFor="otherId">Other</Form.Check.Label>
            </Form.Check>
          </div>
        </Form.Group>
      </Row>
      <Row className="">
        {/* <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Opportunity Name</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
              <Form.Control
                {...register("opportunityName")}
                placeholder="Opportunity Name"
              />
            </InputGroup>
            {errors.opportunityName && (
              <span className="text-danger">
                {errors.opportunityName.message}
              </span>
            )}
          </Form.Group>
        </Col> */}

        <Col md={4}>
          <Form.Group className="mb-3">
            <div className="d-flex align-items-center justify-content-between">
              <Form.Label className="required">Opportunity ID</Form.Label>
              {(isSuperAdmin || isDeptHead) && rfq_id && (
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    orderMade === 1 ? (
                      <Tooltip id="tooltip-rfq-edit">
                        Cannot edit as order is already generated for this
                        opportunity
                      </Tooltip>
                    ) : (
                      <></>
                    )
                  }
                >
                  <span
                    className="trash_icon"
                    onClick={() => {
                      if (orderMade !== 1) {
                        openRfqPopup();
                      }
                    }}
                    style={{
                      cursor: orderMade === 1 ? "not-allowed" : "pointer",
                      opacity: orderMade === 1 ? 0.6 : 1,
                    }}
                  >
                    <IconEdit size={20} stroke={1} />
                  </span>
                </OverlayTrigger>
              )}
              {/* {(isSuperAdmin || isDeptHead) && rfq_id && (
                <span
                  className="trash_icon"
                  onClick={openRfqPopup}
                  style={{ cursor: "pointer" }}
                >
                  <IconEdit size={20} stroke={1} />
                </span>
              )} */}
            </div>
            <Form.Control
              {...register("rfqId")}
              placeholder="Enter N/A"
              defaultValue={"N/A"}
              disabled={isEditing}
            />

            {errors.rfqId && (
              <span className="text-danger">{errors.rfqId.message}</span>
            )}
            <Form.Text>
              Enter NA if you don't have one. Please don't make up your own
              number.
            </Form.Text>
          </Form.Group>
        </Col>

        <Col md={4}>
          {/* <Form.Group className="mb-3">
            <Form.Label className="required">Contract Vehicle</Form.Label>
            <InputGroup>
              <Form.Select
                {...register("contractVehicle")}
                disabled={isEditing}
                value={contractVehicleSelected || ""}
                onChange={(e) => {
                  const selectedValue = e.target.value;
                  setValue("contractVehicle", selectedValue);
                  selectContractVehicle(selectedValue);
                }}
              >
                <option>Select a contract vehicle</option>
                {fetchdata?.data?.map((vehicle, index) => (
                  <option key={index} value={vehicle.id}>
                    {vehicle.name}
                  </option>
                ))}
              </Form.Select>
            </InputGroup>
            {errors.contractVehicle && (
              <span className="text-danger">
                {errors.contractVehicle.message}
              </span>
            )}
          </Form.Group> */}
          <Form.Group className="mb-3">
            <Form.Label className="required">Contract Vehicle</Form.Label>
            <InputGroup>
              <TreeSelect
                value={
                  contractVehicleSelected
                    ? String(contractVehicleSelected)
                    : null
                }
                onChange={(e) => {
                  const selectedKey = e.value;
                  setValue("contractVehicle", selectedKey);
                  selectContractVehicle(selectedKey);
                }}
                options={contractVehicleNodes}
                placeholder="Select a contract vehicle"
                filter
                filterPlaceholder="Search contract vehicle"
                disabled={isEditing}
                style={{ width: "100%" }}
              />
            </InputGroup>
            {errors.contractVehicle && (
              <span className="text-danger">
                {errors.contractVehicle.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group className="mb-3">
            <Form.Label>Customer Name</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
              <Form.Control
                style={{ textTransform: "capitalize" }}
                {...register("organization_name")}
                placeholder="Enter Customer Name"
                onChange={handleSearchByName}
              />
            </InputGroup>
            <div>
              {suggestionData?.data?.length > 0 &&
                searchDebounces?.searchName?.length > 0 && (
                  <div className="suggestions_box" ref={suggestionBoxRef}>
                    <div className="table-responsive">
                      <Table>
                        <tbody>
                          {suggestionData?.data?.map((item, index) => (
                            <tr
                              key={index}
                              onClick={() => handleSelectOrganization(item)}
                              style={{ cursor: "pointer" }}
                            >
                              <td>{item?.display_name}</td>
                              <td>{`${item?.first_name || ""}`}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                )}
            </div>
            {errors.organization_name && (
              <span className="text-danger">
                {errors.organization_name.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>Opportunity Description</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconFileDescription stroke={1} />
              </InputGroup.Text>
              <Form.Control
                as="textarea"
                {...register("Opportunity_Description")}
                placeholder="Enter Description"
                style={{
                  height: "auto",
                  minHeight: "80px",
                  resize: "none",
                }}
                onInput={(e) => {
                  e.target.style.height = "auto";
                  e.target.style.height = `${e.target.scrollHeight}px`;
                }}
              />
            </InputGroup>
            {errors.Opportunity_Description && (
              <span className="text-danger">
                {errors.Opportunity_Description.message}
              </span>
            )}
          </Form.Group>
        </Col>
      </Row>
      <Row className="">
        <Col lg={3} md={6} xs={6}>
          <Form.Group className="mb-3">
            <Form.Label className="">Order Type</Form.Label>
            <InputGroup>
              <Form.Select
                {...register("ordertype")}
                // value={contractVehicleSelected}
                // onChange={(e) => setContractVehicleSelected(e.target.value)}
              >
                {/* <option value="">Select a type</option> */}
                <option value="DS">Dropship</option>
                <option value="CRK">Consolidate / Repack </option>
                <option value="M">Manufacturing</option>
                <option value="KIT">Kit</option>
                <option value="S">Stock</option>
              </Form.Select>
            </InputGroup>
            {errors.ordertype && (
              <span className="text-danger">{errors.ordertype.message}</span>
            )}
          </Form.Group>
        </Col>
        <Col lg={3} md={6} xs={6}>
          <Form.Group className="mb-3">
            <Form.Label className="">Order Payment Type</Form.Label>
            <InputGroup>
              <Form.Select {...register("order_Payment_Type")}>
                <option value="">Select a type</option>
                <option value="invoiced">Invoiced</option>
                <option value="pre-paid">Pre-Paid</option>
                <option value="post-paid">Post-Paid</option>
              </Form.Select>
            </InputGroup>
            {errors.order_Payment_Type && (
              <span className="text-danger">
                {errors.order_Payment_Type.message}
              </span>
            )}
          </Form.Group>
        </Col>
        <Col lg={3} md={6} xs={6}>
          <Form.Group className="mb-3">
            <Form.Label className="required">Date Created</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconCalendarWeek stroke={1} />
              </InputGroup.Text>
              <Controller
                name="publishedDate"
                control={control}
                defaultValue={new Date()}
                rules={{ required: "Published date is required" }}
                render={({ field }) => (
                  <DatePicker
                    {...field}
                    selected={field.value ? new Date(field.value) : new Date()}
                    onChange={(date) => field.onChange(date)}
                    dateFormat="MM/dd/yyyy"
                    // minDate={new Date()}
                    placeholderText="Select Date"
                    className="form-control required"
                    yearDropdownItemNumber={20}
                    scrollableYearDropdown
                    showYearDropdown
                    showMonthDropdown
                  />
                )}
              />
            </InputGroup>
            {errors.publishedDate && (
              <span className="text-danger">
                {errors.publishedDate.message}
              </span>
            )}
          </Form.Group>
        </Col>

        <Col lg={3} md={6} xs={6}>
          <Form.Group className="mb-3">
            <Form.Label>Valid For</Form.Label>
            <InputGroup>
              <Form.Select {...register("Valid_For")} defaultValue={30}>
                <option value={30}>30 Days</option>
                <option value={60}>60 Days</option>
                <option value={90}>90 Days</option>
                <option value={120}>120 Days</option>
                <option value={"N/A"}>N/A</option>
              </Form.Select>
            </InputGroup>
            {errors.Valid_For && (
              <span className="text-danger">{errors.Valid_For.message}</span>
            )}
            <Form.Text>
              30, 60, 90, 120 Days. Default Value is 30 Days
            </Form.Text>
          </Form.Group>
        </Col>

        {customFields.length > 0 &&
          customFields.map((field, index) => (
            <Col xs={4} key={index}>
              <Form.Group className="mb-3">
                <div className="d-flex align-items-center justify-content-between">
                  <Form.Label>{field.field_name}</Form.Label>
                  <span
                    className="trash_icon"
                    onClick={() => handleRemoveCustomField(index)}
                  >
                    <IconTrash size={20} stroke={1} />
                  </span>
                </div>
                {field.type === "number" && (
                  <Form.Control
                    type="text"
                    onKeyDown={handleKeyDown}
                    placeholder={`Enter ${field.field_name}`}
                    {...register(`custom_fields[${index}].value`)}
                  />
                )}
                {field.type === "text" && (
                  <Form.Control
                    type="text"
                    placeholder={`Enter ${field.field_name}`}
                    {...register(`custom_fields[${index}].value`)}
                  />
                )}
                {field.type === "date" && (
                  <InputGroup>
                    <InputGroup.Text>
                      <IconCalendarWeek stroke={1} />
                    </InputGroup.Text>
                    <Controller
                      name={`custom_fields[${index}].value`}
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                          {...field}
                          selected={field.value ? new Date(field.value) : null}
                          onChange={(date) => field.onChange(date)}
                          dateFormat="MM/dd/yyyy"
                          // minDate={new Date()}
                          placeholderText={`Select ${
                            field.field_name || "Date"
                          }`}
                          className="form-control"
                          showMonthDropdown
                          showYearDropdown
                        />
                      )}
                    />
                  </InputGroup>
                )}
                {field.type === "dropdown" && (
                  <Form.Select {...register(`custom_fields[${index}].value`)}>
                    <option value="">Select {field.field_name}</option>
                    {field.options?.map((opt, optIndex) => (
                      <option key={optIndex} value={opt}>
                        {opt}
                      </option>
                    ))}
                  </Form.Select>
                )}
                {errors.custom_fields?.[index]?.value && (
                  <span className="text-danger">
                    {errors.custom_fields[index].value.message}
                  </span>
                )}
              </Form.Group>
            </Col>
          ))}
      </Row>
      <Row>
        <Col lg={9} md={8}>
          <Form.Group className="mb-3">
            <Form.Label>Custom Fields</Form.Label>
            <InputGroup className="custom-dropdown mb-3">
              <DropdownButton
                variant="outline-secondary"
                title={fieldType || "Select Type"}
                id="input-group-dropdown-1"
                onSelect={(type) => setFieldType(type)}
              >
                <Dropdown.Item eventKey="number">Number</Dropdown.Item>
                <Dropdown.Item eventKey="text">Text</Dropdown.Item>
                <Dropdown.Item eventKey="date">Date</Dropdown.Item>
                <Dropdown.Item eventKey="dropdown">Dropdown</Dropdown.Item>
              </DropdownButton>
              <Form.Control
                aria-label="Field Name"
                value={fieldName}
                onChange={(e) => setFieldName(e.target.value)}
                // placeholder="Enter field name"
                placeholder={
                  fieldType === "dropdown"
                    ? 'e.g. "DHS Order Type; Field, Academy, N/A"'
                    : "Enter field name"
                }
              />
            </InputGroup>
          </Form.Group>
        </Col>

        <Col lg={3} md={4}>
          <Form.Label className="form-label d-none d-sm-block">
            &nbsp;
          </Form.Label>
          <div className="d-flex gap-2">
            <Button
              className="flex-grow-1"
              onClick={handleAddCustomField}
              variant="warning"
            >
              Add
            </Button>
            <Button
              className="flex-grow-1"
              variant="outline-secondary"
              onClick={handleCancelCustomField}
            >
              Cancel
            </Button>
          </div>
        </Col>
      </Row>
      {customFieldError && (
        <span className="text-danger mt-1">{customFieldError}</span>
      )}
    </>
  );
}
export default GeneralInformationForm;
